/**
 * July 2022
 * @file Constant values for the custom library (JFM).
 * @author Jorge Flores Miguel <jorgekain00@gmail.com>
 * @version 1.1.1.001
 */

/**
 * Header content type for interchange data between AJAX communications.
 * @typedef {Object} CONTENTTYPE 
 * @property {string} FORMDATA Form data to upload files.
 * @property {string} JSON Json data.
 * @property {string} XML Xml data.
 * @property {string} TEXT Html/text data.
 * @property {string} ZIP Zip file.
 * @property {string} XEXCEL Excel xml.
 */

/**
 * Fetch API mode.
 * @typedef {Object} FETCHMODES
 * @property {string} SAMEORIGIN Ajax Requests for the same origin (Host).
 * @property {string} CORS Ajax Requests for cross site.
 */

/**
 * Replace result mode after submit a form.
 * @typedef {Object} REPLACEMODE
 * @property {string} REPLACE Replace the entire Form tag with the new content
 * @property {string} INSERTAFTER Insert content after the Form tag
 * @property {string} INSERTBEFORE Insert content before the Form tag
 */

/**
 * @typedef {Object} ATTEMPTS #Number of attempts for different situations.
 * @property {Number} AJAX #Number of attempts for AJAX communications.
 */

/**
 * @typedef {Array} CONTAINER_COLLECTION valid container collection.
 */

/**
 * Constant values for general porpuse
 * @typedef {Object} CONSTANTS
 * @property {CONTENTTYPE} CONTENTTYPE Header content type for interchange data between AJAX communications.
 * @property {FETCHMODES} FETCHMODES Fetch API mode.
 * @property {ICONS} ICONS Icon type for alert messages.
 * @property {REPLACEMODE} REPLACEMODE Replace result mode after submit a form.
 * @property {ATTEMPTS} ATTEMPTS #Number of attempts for different situations.
 * @property {CONTAINER_COLLECTION} CONTAINER_COLLECTION valid container collection.
 */

/**
 * Several constant values for general purpose.
 * @type {CONSTANTS}
 * @constant
 */
const JFM_CONST = {
    CONTENTTYPE: {
        FORMDATA: 'multipart/form-data',
        JSON: 'application/json',
        XML: 'text/xml',
        TEXT: 'text/html',
        ZIP: 'application/zip',
        XEXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    FETCHMODES: {
        SAMEORIGIN: 'same-origin',
        CORS: 'cors'
    },
    REPLACEMODE: {
        REPLACE: 'REPLACE',
        INSERTAFTER: 'AFTER',
        INSERTBEFORE: 'BEFORE'
    },
    ATTEMPTS: {
        AJAX: 3
    },
    CONTAINER_COLLECTION: [
        'DIV',
        'FORM',
        'SECTION',
        'TABLE',
        'FIELDSET',
        'ASIDE',
        'FOOTER',
        'HEADER',
        'NAV',
        'ARTICLE'
    ]
};